import { memo } from 'react'

import Header from '../header/Header'
import SmavaFooter from '../footer/smava'
import Footer from '../footer/Footer'
import NoData from '../banklist/NoData'
import BankListComponent from '../banklist'
import LoadingSkeleton from '../banklist/LoadingSkeleton'
import { BankListItem, IBankList } from '../banklist/typings'
import { BankListContext } from '../banklist/BankListContext'
import BankListLoanSelector from '../banklist/loan-selector'

import { isSmava } from '../../utils/getTenantInfo.utils'
import { LOADING_FETCH_STATUS_CODE } from '../../hooks/useBankList'

interface BankListPageProps {
  hasHeader?: boolean
  extendedFooter?: boolean
  bankListContextData: any
  currentBankList: BankListItem[]
  fetchStatus: number
}

const BankList = ({ bankList }: IBankList) =>
  bankList.length > 0 ? <BankListComponent bankList={bankList} /> : <NoData />

const BankListPage = ({
  hasHeader = true,
  extendedFooter = true,
  bankListContextData,
  currentBankList,
  fetchStatus,
}: BankListPageProps) => (
  <>
    {hasHeader && <Header isBankList />}
    <BankListContext.Provider value={bankListContextData}>
      <BankListLoanSelector />
      {fetchStatus !== LOADING_FETCH_STATUS_CODE ? (
        <BankList bankList={currentBankList} />
      ) : (
        <LoadingSkeleton />
      )}
    </BankListContext.Provider>
    {isSmava ? (
      <SmavaFooter extended={!!extendedFooter} />
    ) : (
      <Footer extended={!!extendedFooter} />
    )}
  </>
)

export default memo(BankListPage)
